export const items = [
  {
    id: "INI",
    nameMenu: "Inicio",
    titlePage: "Inicio",
    titleTab: "Inicio",
    menuPadre: null,
  },

  {
    id: "ADM",
    nameMenu: "Administración",
    titlePage: "Administración",
    titleTab: "Admin.",
    menuPadre: null,
  },
  {
    id: "CLI",
    nameMenu: "Clientes",
    titlePage: "Administracion de Clientes",
    titleTab: "Clientes",
    menuPadre: "ADM",
  },
  {
    id: "SUS",
    nameMenu: "Clave Suscripción",
    titlePage: "Administración de Clave Suscripción",
    titleTab: "Clave Suscripción",
    menuPadre: "ADM",
  },
  {
    id: "PRV",
    nameMenu: "Proveedores",
    titlePage: "Administración de Proveedores",
    titleTab: "Proveedores",
    menuPadre: "ADM",
  },
  {
    id: "USU",
    nameMenu: "Usuarios",
    titlePage: "Administración de Usuarios",
    titleTab: "Usuarios",
    menuPadre: "ADM",
  },
  {
    id: "PRO",
    nameMenu: "Productos/Servicios",
    titlePage: "Administración de Productos/Servicios",
    titleTab: "Productos/Servicios",
    menuPadre: "ADM",
  },
  {
    id: "PAR",
    nameMenu: "Partners",
    titlePage: "Administración para Partners",
    titleTab: "Partners",
    menuPadre: "ADM",
  },
  {
    id: "DCE",
    nameMenu: "Comprobantes por Empresa",
    titlePage: "Detalle de Comprobantes Por Empresa",
    titleTab: "Det. Comp. por Empresa",
    menuPadre: "ADM",
  },
  {
    id: "ADP",
    nameMenu: "Adm. Partners",
    titlePage: "Administración de Partners",
    titleTab: "Adm. Partners",
    menuPadre: "ADM",
  },
  {
    id: "CSE",
    nameMenu: "Puntos de Emisión",
    titlePage: "Administración de Puntos de Emisión",
    titleTab: "Admin. Secuenciales",
    menuPadre: "ADM",
  },
  {
    id: "ASE",
    nameMenu: "Asignación de Puntos de Emisión",
    titlePage: "Asignación de Puntos de Emisión",
    titleTab: "Asignación Secuenciales",
    menuPadre: "ADM",
  },
  {
    id: "AEM",
    nameMenu: "Empresas",
    titlePage: "Administración de Empresas",
    titleTab: "Admin. Empresas",
    menuPadre: "ADM",
  },

  {
    id: "ACT",
    nameMenu: "Contadores",
    titlePage: "Administración de Contadores",
    titleTab: "Admin. Contadores",
    menuPadre: "ADM",
  },
  {
    id: "APQ",
    nameMenu: "Pagos",
    titlePage: "Administración de Pagos",
    titleTab: "Admin. Pagos",
    menuPadre: "ADM",
  },

  {
    id: "GEN",
    nameMenu: "Generación de Comprobantes",
    titlePage: "Generación de Comprobantes",
    titleTab: "Generación Comprobantes",
    menuPadre: null,
  },

  {
    id: "REP",
    nameMenu: "Repositorio de Comprobantes",
    titlePage: "Repositorio de Comprobantes",
    titleTab: "Repositorio de Comprobantes",
    menuPadre: null,
  },
  {
    id: "REPO",
    nameMenu: "Reporte de Comprobantes",
    titlePage: "Reporte de Comprobantes",
    titleTab: "Reporte de Comprobantes",
    menuPadre: null,
  },
  {
    id: "EVE",
    nameMenu: "Eventos",
    titlePage: "Eventos",
    titleTab: "Eventos",
    menuPadre: null,
  },
  {
    id: "EAN",
    nameMenu: "Eventos de Anulación",
    titlePage: "Eventos de Anulación",
    titleTab: "Eventos de Anulación",
    menuPadre: "EVE",
  },
  {
    id: "EMA",
    nameMenu: "Eventos de Manifestación",
    titlePage: "Eventos de Manifestación",
    titleTab: "Eventos de Manifestación",
    menuPadre: "EVE",
  },  
  {
    id: "CON",
    nameMenu: "Consultas",
    titlePage: "Consultas",
    titleTab: "Consultas",
    menuPadre: null,
  },
  {
    id: "CMR",
    nameMenu: "Consulta masiva de RUCs",
    titlePage: "Consulta masiva de RUCs",
    titleTab: "Consulta masiva de RUCs",
    menuPadre: "COM",
  },
  {
    id: "AUT",
    nameMenu: "Emitidos Autorizados",
    titlePage: "Emitidos Autorizados",
    titleTab: "Comp. Emitidos Autorizados",
    menuPadre: "REP",
  },
  {
    id: "NAU",
    nameMenu: "Emitidos No Autorizados",
    titlePage: "Emitidos No Autorizados",
    titleTab: "Comp. Emitidos No Autorizados",
    menuPadre: "REP",
  },
  {
    id: "PEN",
    nameMenu: "Pendientes",
    titlePage: "Pendientes",
    titleTab: "Comp. Pendientes",
    menuPadre: "REP",
  },
  {
    id: "ANU",
    nameMenu: " Anulados",
    titlePage: " Anulados",
    titleTab: "Comp. Anulados",
    menuPadre: "REP",
  },
  {
    id: "CRA",
    nameMenu: "Recibidos",
    titlePage: "Recibidos",
    titleTab: "Comprobantes Recibidos",
    menuPadre: "REP",
  },
  {
    id: "CAC",
    nameMenu: "Cargar Comprobantes Recibidos",
    titlePage: "Cargar Comprobantes Recibidos",
    titleTab: "Cargar Comprobantes Recibidos",
    menuPadre: "REP",
  },
  // {
  //   "id": "FAC",
  //   "nameMenu": "Factura",
  //   "titlePage": "Factura",
  //   titleTab: "Factura",
  //   "menuPadre": "GEN"
  // },
  {
    id: "FUE",
    nameMenu: "Creación del comprobante por excel",
    titlePage: "Creación del comprobante por excel",
    titleTab: "Creación del comprobante por excel",
    menuPadre: "GEN",
  },
  {
    id: "FOP",
    nameMenu: "Factura Operación Interna",
    titlePage: "Factura Operación Interna",
    titleTab: "Factura Operación Interna",
    menuPadre: "GEN",
  },
  {
    id: "FEX",
    nameMenu: "Factura de Exportación",
    titlePage: "Factura de Exportación",
    titleTab: "Factura de Exportación",
    menuPadre: "GEN",
  },
  {
    id: "FIM",
    nameMenu: "Factura de Importación",
    titlePage: "Factura de Importación",
    titleTab: "Factura de Importación",
    menuPadre: "GEN",
  },
  {
    id: "FZF",
    nameMenu: "Factura de Zona Franca",
    titlePage: "Factura de Zona Franca",
    titleTab: "Factura de Zona Franca",
    menuPadre: "GEN",
  },
  {
    id: "NDG",
    nameMenu: "Nota de Débito Genérica",
    titlePage: "Nota de Débito Genérica",
    titleTab: "Nota de Débito Genérica",
    menuPadre: "GEN",
  },
  {
    id: "NDR",
    nameMenu: "Nota de Débito Referente a Una o Varias FE",
    titlePage: "Nota de Débito Referente a Una o Varias FE",
    titleTab: "Nota de Débito Referente a Una o Varias FE",
    menuPadre: "GEN",
  },
  {
    id: "NCG",
    nameMenu: "Nota de Crédito Genérica",
    titlePage: "Nota de Crédito Genérica",
    titleTab: "Nota de Crédito Genérica",
    menuPadre: "GEN",
  },
  {
    id: "NCR",
    nameMenu: "Nota de Crédito Referente a Una o Varias FE",
    titlePage: "Nota de Crédito Referente a Una o Varias FE",
    titleTab: "Nota de Crédito Referente a Una o Varias FE",
    menuPadre: "GEN",
  },
  {
    id: "REE",
    nameMenu: "Reembolso",
    titlePage: "Reembolso",
    titleTab: "Reembolso",
    menuPadre: "GEN",
  },
  {
    id: "FOE",
    nameMenu: "Factura Operación Extranjera",
    titlePage: "Factura Operación Extranjera",
    titleTab: "Factura Operación Extranjera",
    menuPadre: "GEN",
  },
  {
    id: "AGC",
    nameMenu: "Administración Generación de Comprobantes",
    titlePage: "Administración Generación de Comprobantes",
    titleTab: "Administración Generación de Comprobantes",
    menuPadre: "ADM",
  },
  // {
  //   "id": "RET",
  //   "nameMenu": "Retención",
  //   "titlePage": "Retención",
  //   titleTab: "Retención",
  //   "menuPadre": "GEN"
  // },
  // {
  //   "id": "CRE",
  //   "nameMenu": "Nota de Crédito",
  //   "titlePage": "Nota de Crédito",
  //   titleTab: "Nota de Crédito",
  //   "menuPadre": "GEN"
  // },
  // {
  //   "id": "DEB",
  //   "nameMenu": "Nota de Débito",
  //   "titlePage": "Nota de Débito",
  //   titleTab: "Nota de Débito",
  //   "menuPadre": "GEN"
  // },
  // {
  //   "id": "LIQ",
  //   "nameMenu": "Liquidación de Compra",
  //   "titlePage": "Liquidación de Compra",
  //   titleTab: "Liquidación de Compra",
  //   "menuPadre": "GEN"
  // },
  // {
  //   "id": "GUI",
  //   "nameMenu": "Guía de Remisión",
  //   "titlePage": "Guía de Remisión",
  //   titleTab: "Guía de Remisión",
  //   "menuPadre": "GEN"
  // },
  {
    id: "RCE",
    nameMenu: "Reporte Comprobantes Emitidos",
    titlePage: "Reporte Comprobantes Emitidos",
    titleTab: "Reporte comprobantes emitidos",
    menuPadre: "REPO",
  },
  {
    id: "CPD",
    nameMenu: "Reporte Comprobantes Estado PAC - DGI",
    titlePage: "Reporte Comprobantes Estado PAC - DGI",
    titleTab: "Reporte Comprobantes Estado PAC - DGI",
    menuPadre: "REPO",
  },
  {
    id: "RCR",
    nameMenu: "Reporte Comprobantes Recibidos",
    titlePage: "Reporte Comprobantes Recibidos",
    titleTab: "Reporte comprobantes recibidos",
    menuPadre: "REPO",
  },
  {
    id: "RIV",
    nameMenu: "Reporte Informe de Ventas",
    titlePage: "Reporte Informe de Ventas",
    titleTab: "Reporte Informe de Ventas",
    menuPadre: "REPO",
  },
  {
    id: "RFR",
    nameMenu: "Reporte Comprobantes No Autorizados",
    titlePage: "Reporte Comprobantes No Autorizados",
    titleTab: "Reporte Comprobantes No Autorizados",
    menuPadre: "REPO",
  },
  {
    id: "RED",
    nameMenu: "Reporte Comprobantes Emitidos Con Detalles",
    titlePage: "Reporte Comprobantes Emitidos Con Detalles",
    titleTab: "Reporte Comprobantes Emitidos Con Detalles",
    menuPadre: "REPO",
  },
  {
    id: "RFA",
    nameMenu: "Reporte Comprobantes Anulados",
    titlePage: "Reporte Comprobantes Anulados",
    titleTab: "Reporte Comprobantes Anulados",
    menuPadre: "REPO",
  },
  {
    id: "RET",
    nameMenu: "Reporte Comprobantes Totalizado",
    titlePage: "Reporte Comprobantes Totalizado",
    titleTab: "Reporte Comprobantes Totalizado",
    menuPadre: "REPO",
  },
];
